import { useQuery } from "@tanstack/react-query";
import { swingCollectionsService } from "../../../services/swingCollections";
import { useUserData } from "../../../hooks/useUserData";

export function useAllSwingCollectionsByUserId() {
  const { userData } = useUserData();

  const { data, ...rest } = useQuery({
    enabled: !!userData?.uid,
    queryKey: ["getAllSwingCollectionsByUserId_key", userData?.uid],
    retry: 1,
    staleTime: 5 * 60 * 1000,
    queryFn: () =>
      swingCollectionsService.getAllSwingCollectionsByUserId({
        userId: userData?.uid,
      }),
  });

  return { collections: data?.items, ...rest };
}
